import React from 'react';
import { css } from 'styled-components';
import { EvoRoomCancellationTypeSelection } from '@/app/components/hotel-detail/evo/rooms/EvoRoomCancellationTypeSelection';
import {
  RoomMobileHeader,
  RoomMobileImageGallery,
  RoomMobileInfoSection,
} from '@/app/components/hotel-detail/rooms/RoomPanelMobileParts';

type EvoRoomPanelModalContentMobileProps = {
  room: RoomType;
  selectedMealPlan?: MealPlanType;
  onSelectMealPlan?: (selectedMealPlan: MealPlanType) => void;
} & React.HTMLAttributes<HTMLElement>;

// Mobile body of the EVO room-details modal: a full-bleed gallery, the room info at Body size, and the
// cancellation-type selection (bordered). The "Continue" CTA lives in the modal footer (RoomPanelModal).
export function EvoRoomPanelModalContentMobile(props: EvoRoomPanelModalContentMobileProps) {
  const { room, selectedMealPlan, onSelectMealPlan, ...rest } = props;
  const roomsLeft = room.configurations?.[0]?.roomsLeft ?? 0;

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
      `}
      {...rest}
    >
      <RoomMobileImageGallery
        images={room.images}
        height={200}
        counterPosition={`
          bottom: 16px;
          right: 16px;
        `}
      />

      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding: 16px 16px 24px;
        `}
      >
        <RoomMobileHeader roomName={room.name} roomsIncludedInPrice={room.roomsIncludedInPrice} roomsLeft={roomsLeft} />

        <RoomMobileInfoSection room={room} selectedMealPlan={selectedMealPlan} textVariant="Body" />

        {selectedMealPlan && onSelectMealPlan && (
          <EvoRoomCancellationTypeSelection
            room={room}
            selectedMealPlan={selectedMealPlan}
            onSelectMealPlan={onSelectMealPlan}
            bordered={true}
          />
        )}
      </div>
    </div>
  );
}
